import {
  Card,
  CardBody,
  Form,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  CardHeader,
  CardTitle,
  Button,
  CardFooter,
} from "reactstrap";
import { NavLink } from "react-router-dom";
import { useState, React, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
import { MainContext } from "context/MainContext.js";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";
LoadingOverlay.propTypes = undefined;

const SubscriberEditConfirm = () => {
  const history = useHistory();
  const location = useLocation();

  const [subscribers, setSubscribers] = useState([]);
  const [formError, setFormError] = useState(false);

  const [errorMsg, setErrorMsg] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["devices.subscribers.edit"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  // Subscriber IDs coming from the location on bulk edit mode
  const [bulklist, setBulklist] = useState(
    location.state ? location.state.bulklist : "",
  );

  // Subscriber IDs coming from the location on bulk edit mode
  const [changes, setChanges] = useState(
    location.state ? location.state.changes : [],
  );

  useEffect(() => {
    // Sort the Changes list in alphabetical order
    const sortedChanges = [...changes].sort((a, b) => {
      const keyA = Object.keys(a)[0];
      const keyB = Object.keys(b)[0];
      return keyA.localeCompare(keyB);
    });
    setChanges(sortedChanges);
  }, []);

  const formatKey = (key) => {
    const keyMap = {
      allowedTaggedVlan: "Allowed Tagged VLAN Port #1",
      allowedTaggedVlan2: "Allowed Tagged VLAN Port #2",
      bandwidth: "Bandwidth",
      doubleTagging: "Double Tagging",
      endpointTagging: "Endpoint Tagging Port #1",
      endpointTagging2: "Endpoint Tagging Port #2",
      outerTag: "Outer Tag Port #1",
      poeModeCtrl: "POE",
      remappedVlanId: "Remapped VID",
      uplinkPort: "Uplink Port",
      vlan: "VLAN Port #1",
      vlan2: "VLAN Port #2",
    };
    return keyMap[key] || key;
  };

  const formatValue = (key, value) => {
    if (key == "bandwidth") {
      return value.replaceAll("||", " - ");
    }

    return value;
  };

  const redirectToTaskList = () => {
    const location = {
      pathname: "/admin/tasks/list",
      state: { showToast: true, message: "Tasks Created Successfully" },
    };
    history.push(location);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormError(false);
    setShowLoading(true);

    fetch("/api/v1/subscriber/bulk/confirmation", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        bulklist: bulklist,
      },
      body: JSON.stringify(changes),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status == 200) {
          redirectToTaskList();
        } else {
          toast.error("An error occured while launching editing tasks ", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />

        {/* ------------------------------------------------------------------------------------------------------------------------------ */}
        {/* --------------------------------------------------------- BREADCRUMB --------------------------------------------------------- */}
        {/* ------------------------------------------------------------------------------------------------------------------------------ */}
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/subscribers/list",
                      }}
                    >
                      Subscribers
                      {bulklist ? " <" + bulklist.length + " selected>" : ""}
                    </NavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Edit</BreadcrumbItem>
                  <BreadcrumbItem>Confirmation</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* ------------------------------------------------------------------------------------------------------------------------------ */}
        {/* -------------------------------------------------------- ERROR MESSAGE ------------------------------------------------------- */}
        {/* ------------------------------------------------------------------------------------------------------------------------------ */}
        <Row>
          <Col>
            {errorMsg.length > 0 ? (
              <div
                style={{
                  backgroundColor: "#FFC0A4",
                  border: "1px solid #ef8157",
                  color: "#66615b",
                  paddingTop: "15px",
                  marginBottom: "15px",
                }}
              >
                <ul>
                  {errorMsg.map((d, index) => (
                    <li key={index}>{d}</li>
                  ))}
                </ul>
              </div>
            ) : (
              ""
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            <Form onSubmit={handleSubmit}>
              {/* ------------------------------------------------------------------------------------------------------------------------------ */}
              {/* ------------------------------------------------------- CHANGES SUMMARY ------------------------------------------------------ */}
              {/* ------------------------------------------------------------------------------------------------------------------------------ */}
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Changes Summary</CardTitle>
                </CardHeader>

                <CardBody>
                  <div className="bulk-edit-page">
                    <div className="selection-info">
                      <p style={{ fontWeight: "bold" }}>
                        {bulklist.length} subscribers selected
                      </p>
                    </div>
                  </div>
                  {changes &&
                    changes.map((item, index) => (
                      <Row key={index}>
                        <Col>
                          {formatKey(Object.keys(item)[0])} =&gt;{" "}
                          <b>
                            {formatValue(
                              Object.keys(item)[0],
                              Object.values(item)[0].toString(),
                            )}
                          </b>
                        </Col>
                      </Row>
                    ))}
                </CardBody>
                <CardFooter style={{ marginTop: "20px" }}>
                  <Button className="btn-round" color="info" type="submit">
                    Start Changes
                  </Button>
                </CardFooter>
              </Card>
            </Form>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SubscriberEditConfirm;
